<template>
    <div class="w-[110px] mx-auto">
        <!-- eslint-disable-next-line vue/require-v-for-key -->
        <section v-for="price in aboveTheFoldPrices" class="flex py-0.5">
            <template v-if="price.FormattedQuantity">
                <span>{{ price.FormattedQuantity }}</span>
                <!-- Need this many dots to support ultra-widescreen -->
                <span class="overflow-hidden"
                    >..................................................................................................................................................................................................................</span
                >
                <span>{{ price.FormattedPrice }}</span>
            </template>
            <template v-else>
                <span class="see-website">{{ price.FormattedPrice }}</span>
            </template>
        </section>
        <div v-if="prices.length > breakPoint && !showBelowTheFoldPrices" class="text-center">
            <button class="font-bold mt-2 inline-block link-blue" @click="expandPricing">
                {{ $t("Search.SeeMore") }}
            </button>
        </div>
        <template v-if="prices.length > breakPoint && showBelowTheFoldPrices">
            <!-- eslint-disable-next-line vue/require-v-for-key -->
            <section v-for="price in belowTheFoldPrices" class="flex py-0.5">
                <template v-if="price.FormattedQuantity">
                    <span>{{ price.FormattedQuantity }}</span>
                    <!-- Need this many dots to support ultra-widescreen -->
                    <span class="overflow-hidden"
                        >..................................................................................................................................................................................................................</span
                    >
                    <span>{{ price.FormattedPrice }}</span>
                </template>
                <template v-else>
                    <span class="see-website">{{ price.FormattedPrice }}</span>
                </template>
            </section>
        </template>
    </div>
</template>

<script setup lang="ts">
const { gtag } = useGtag();

interface Price {
    FormattedQuantity: string;
    FormattedPrice: string;
}

const props = defineProps({ prices: { type: Array<Price>, required: true } });

const showBelowTheFoldPrices = ref(false);
const breakPoint = ref(5);

const aboveTheFoldPrices = computed(() => {
    return props.prices.slice(0, breakPoint.value);
});

const belowTheFoldPrices = computed(() => {
    return props.prices.slice(breakPoint.value);
});

onMounted(() => {
    const screenSize = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (screenSize > 992) {
        breakPoint.value = 5;
    } else {
        breakPoint.value = 2;
    }
});

function expandPricing() {
    gtag("event", "Expand", { event_category: "Product", event_label: "Pricing" });
    gtag("event", "results_pricing_expand");
    showBelowTheFoldPrices.value = true;
}
</script>
